import React from 'react';
import { ThemeProvider, Box } from '@mui/material';
import S3FileList from './S3FileList';
import AppHeader from '../Common/AppHeader';
import { theme } from '../../utils/colors';

const S3FilesPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          maxWidth: 1920,
          width: '100%',
          mx: 'auto',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <AppHeader />

        <Box
          sx={{
            maxWidth: 1680,
            width: '100%',
            mx: 'auto',
            bgcolor: 'background.paper',
          }}
        >
          <S3FileList />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default S3FilesPage;
